(function() {
  "use strict";

  angular.module("app").directive("cccRiskRankingMap", cccRiskRankingMap);

  function cccRiskRankingMap() {
    return {
      restrict: "EA",
      scope: false,
      controller: "RiskRankingMapController"
    };
  }
})();
